import { Component, Input } from '@angular/core';
import { ContainerMovementListItem } from '../../../Container/model/ContainerMovementListItem';
import { GaugeTypeEnum } from '../../../Container/enum/GaugeTypeEnum';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-container-job-details',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './container-job-details.component.html',
  styleUrl: './container-job-details.component.scss'
})
export class ContainerJobDetailsComponent {

  @Input()
  currentLegData?: ContainerMovementListItem;

  @Input()
  isInboundJob: boolean = false;

  @Input()
  isIntermodalJob: boolean = false;

  showGaugeTypes() {
    if (this.currentLegData) {
      if (this.currentLegData.isHighGauge && this.currentLegData.isWideGauge) {
        return GaugeTypeEnum.High + ', ' + GaugeTypeEnum.Wide;
      } else if (this.currentLegData.isHighGauge) {
        return GaugeTypeEnum.High;
      } else if (this.currentLegData.isWideGauge) {
        return GaugeTypeEnum.Wide;
      }
    }
    return '';
  }

  getTemperature(temperature: number | null): string {
    if (temperature) {
      return `${temperature} °C`;
    }
    return '';
  }
}
